import { useContext } from 'react';
import { useQuery } from 'react-query';

import { FetchContext } from './context/FetchContext';

import Home from './pages/Home';

const App = () => {
	const fetchContext = useContext(FetchContext);

	const getLogs = async () => {
		try {
			const { data } = await fetchContext.authAxios.get('logs');
			return data?.data;
		} catch (error) {
			console.log(`error?.response	`, error);
		}
	};
	const { isLoading, error, data } = useQuery('logs', getLogs);

	return <Home state={{ isLoading, data, error }} />;
};

export default App;
